jQuery(function($){
  var button          = $('.jc-load-more'),
      seemore         = $('.post-list'),
      doNotDuplicate  = [seemore.attr('data-notin')],
      scrollHandling  = {
        carros:    true,
        motos:     true,
        servicos:  true,
        fanaticos: true,
        section:   true,
        allow:     true,
        reallow: function() {
          scrollHandling.allow = true;
        },
        delay: 1000
      },
      page      = 1;


  //Definindo elements a serem chamados

  var elements = [];

  $(".jc-load-section").each(function(){
    elements.push({"element" : $(this), "scrollHandling": true});
  });


  //Retorna os elements

  var count = 0;

  function loadSections() {
    var deferred = jQuery.Deferred(),
        size  = elements.length;

    elements.forEach(function(el) {

      var offset = el.element.position().top - 2000;

      if(el.scrollHandling && $(this).scrollTop() >= offset) {

        el.scrollHandling = false;

        $.when(loadHomeSection(el.element)).then(function() {
          doNotDuplicate.push(el.element.attr('data-ids'));
          seemore.attr('data-notin',doNotDuplicate);
          count = count + 1;
        });
      }

    });

    //Checa se todas as seções foram carregadas para resolver a promessa

    if (size === count) {
      deferred.resolve();
    }

    return deferred.promise();
  }


  $(document).on('scroll', function(){
    $.when(loadSections()).then(function(){
      if(scrollHandling.allow) {
        
        var offset = $(button).offset().top - $(window).scrollTop();

        if(2000 > offset && seemore) {

          scrollHandling.allow = false;

          $.when(loadMorePosts(seemore,page)).done(function(){
            page++;
            scrollHandling.allow = true;
          });
        }
      }
    });
  });

});
